import { GridFilterItem, GridFilterModel } from '@mui/x-data-grid-pro';

import { IBill } from 'common/src/types/interfaces';

export function getValidInvalidItems(
  items: GridFilterItem[],
): [GridFilterItem[], GridFilterItem[]] {
  if (!items) return [[], []];

  const validItems = [];
  const invalidItems = [];

  items.forEach((i) => {
    const invalidItem =
      i.value === undefined || i.value === null || i.value.length === 0;
    invalidItem ? invalidItems.push(i) : validItems.push(i);
  });

  return [validItems, invalidItems];
}

export function parseFilterQuery(filter: GridFilterModel): GridFilterItem[] {
  if (!filter || !filter.items?.length) return [];

  const queryFields = {
    utility: 'utilityId',
    account: 'accountId',
  };

  type ExtraFilterItemProps = {
    additionalFilters?: GridFilterItem[];
    replaceBaseFilter?: boolean;
  };

  const itemsParsed = filter.items
    .filter((i) => i.value !== undefined && i.value !== null)
    .flatMap((filterItem) => {
      const baseItem = {
        ...filterItem,
        field: queryFields[filterItem.field] ?? filterItem.field,
        value: filterItem.value,
      };

      const { additionalFilters = [], replaceBaseFilter = false } =
        filterItem as ExtraFilterItemProps;

      const mappedAdditionalFilters = additionalFilters.map((extraItem) => ({
        ...extraItem,
        field: queryFields[extraItem.field] ?? extraItem.field,
      }));

      return replaceBaseFilter
        ? mappedAdditionalFilters
        : [baseItem, ...mappedAdditionalFilters];
    });

  return itemsParsed;
}

export function needsAllocationReview(bill: Partial<IBill>) {
  return (
    !bill.masterBillId &&
    bill.isAllocated &&
    bill.allocationTemplate?.needsReview &&
    !bill.allocationsEdited
  );
}
